module.exports = __webpack_public_path__ + "static/eCommerce-3b21fd29e47c2ee96d64cd7e48e3ce96.png";